module.exports = __webpack_public_path__ + "static/media/Workday_Step2b_Image7f.221ea013.jpg";